export default __webpack_public_path__ + "static/media/activeUserIcon.73a6d61b.svg";